import { Pacientes, type Cama, type Paciente } from './api';

export function nombrePaciente(p?: Paciente | null): string {
  if (!p) return '';
  return [p.nombres, p.apellidos].filter(Boolean).join(' ').trim();
}

export function etiquetaPersona(p?: Paciente | null): string {
  if (!p) return '';
  const n = nombrePaciente(p);
  if (n) return n;
  if (p.cui) return `CUI ${p.cui}`;
  return 'Paciente';
}

export function mapaNombresPaciente(list: Paciente[]): Record<string, string> {
  const m: Record<string, string> = {};
  for (const p of list) {
    if (!p.id) continue;
    m[p.id] = etiquetaPersona(p);
  }
  return m;
}

/** Completa nombres por id (el listado de pacientes solo trae los últimos 50). */
export async function completarNombresPaciente(
  mapa: Record<string, string>,
  ids: Array<string | null | undefined>,
): Promise<Record<string, string>> {
  const next = { ...mapa };
  const missing = [...new Set(ids.filter((id): id is string => !!id && !next[id]))];
  await Promise.all(missing.map(async (id) => {
    try {
      next[id] = etiquetaPersona(await Pacientes.uno(id)) || 'Paciente';
    } catch {
      next[id] = 'Paciente';
    }
  }));
  return next;
}

export function etiquetaCama(c?: Cama | null): string {
  if (!c) return '';
  return [c.numero, c.servicio].filter(Boolean).join(' · ');
}

export function mapaCamas(list: Cama[]): Record<string, string> {
  const m: Record<string, string> = {};
  for (const c of list) {
    if (!c.id) continue;
    m[c.id] = etiquetaCama(c) || c.numero || 'Cama';
  }
  return m;
}

export function etiquetaVisible(mapa: Record<string, string>, id?: string | null, fallback = '—'): string {
  if (!id) return fallback;
  return mapa[id] || fallback;
}
